import * as Popover from "@radix-ui/react-popover";
import { DEFAULT_AVATAR, Switch } from "@swivl-mono/ui";
import { useState } from "react";
import { FiLogOut } from "react-icons/fi";
import { MdManageAccounts } from "react-icons/md";

import AccountModel from "../../../../../Models/Account/AccountModel";
import { Member } from "../../../../../Models/Member/Member.Current";
import MembersModel from "../../../../../Models/Member/Members.Model";
import { openAccountSettings } from "../AccountSettingsModal/AccountSettingsModal";
import "./NavBarRightSection.scss";

export function UserAvatarPopover(): React.ReactNode {
  const [isOpen, setIsOpen] = useState(false);
  const { isAvailable } = MembersModel.useState((s) => s);

  function handleOpenAccountSettings(): void {
    setIsOpen(false);
    openAccountSettings();
  }

  function handleLogOut(): void {
    setIsOpen(false);
    AccountModel.logOut();
  }

  return (
    <Popover.Root open={isOpen} onOpenChange={setIsOpen}>
      <Popover.Trigger asChild>
        <div className="UserAvatarPopover-wrapper">
          <button className="UserAvatarPopover-trigger" aria-label="User menu">
            <img src={Member.avatarURL || DEFAULT_AVATAR} alt="User Avatar" />
          </button>
          {isAvailable && <span className="availability-dot" />}
        </div>
      </Popover.Trigger>

      <Popover.Portal>
        <Popover.Content side="bottom" align="end" sideOffset={8} className="UserAvatarPopover-content">
          <div className="availability-row">
            <span className="body-sm text-grey-700">Availability</span>
            <Switch
              name="isAvailable"
              on={isAvailable}
              onChange={() => {
                MembersModel.setAvailability(!isAvailable);
              }}
            />
          </div>
          <div className="dropdown-divider" />
          <div>
            <button
              type="button"
              className="body-sm flex w-full cursor-pointer items-center gap-2 border-none bg-transparent py-1.5 text-grey-700 hover:text-orange-500"
              onClick={handleOpenAccountSettings}
            >
              <MdManageAccounts />
              <span>Account Settings</span>
            </button>
            <div className="dropdown-divider" />
            <button
              type="button"
              className="body-sm flex w-full cursor-pointer items-center gap-2 border-none bg-transparent py-1.5 text-grey-700 hover:text-orange-500"
              onClick={handleLogOut}
            >
              <FiLogOut />
              <span>Log out</span>
            </button>
          </div>
        </Popover.Content>
      </Popover.Portal>
    </Popover.Root>
  );
}
